import * as go from 'gojs';
import { getImageMultislopeScreen } from 'unitData/MultislopeScreen/getImageMultislopeScreen';
import {
  getDeckPortPanel,
  getImageBinding,
  getIOPort,
  makeNode,
} from '../../utils';
import type { ScreenNodeData } from 'gojs/types';

const alignScreenPort = (
  mirrored: boolean,
  portIndex: number,
  decks?: number,
) => {
  const x = mirrored ? 0 : 1;

  if (decks === 1) {
    switch (portIndex) {
      case 0:
        return new go.Spot(x, 4 / 6);
      case 1:
        return new go.Spot(0.5, 1);
    }
  } else {
    switch (portIndex) {
      case 0:
        return new go.Spot(x, 3 / 6);
      case 1:
        return new go.Spot(x, 4 / 6);
      case 2:
        return new go.Spot(0.5, 1);
    }
  }
};

const MultislopeScreenTemplate = makeNode(
  getImageBinding('', (node: ScreenNodeData) =>
    getImageMultislopeScreen(node.nbrOfDecks, node.modelName),
  ),
  [
    getIOPort(go.Spot.Top, 'input'),
    getDeckPortPanel(0, alignScreenPort),
    getDeckPortPanel(1, alignScreenPort),
    getDeckPortPanel(2, alignScreenPort, (node) => node.nbrOfDecks >= 2),
  ],
);

export default MultislopeScreenTemplate;
